export default "{\n    \"groupings\": {\n        \"favourited\": \"Favorited\"\n    }\n}\n"